// Libraries
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Utilities
import { fetchProject } from 'api/rest';
import { getEngagementReport } from 'api/v3/public';
import { jsonaDeserialize } from 'common/utils/helpers';
import { transformBackendData } from 'engagementReport/utils/helpers';

// Components
import Header from 'header/components/Header';
import SocialFooter from 'common/components/SocialFooter';
import Footer from 'common/components/Footer';
import EngagementReportHero from 'engagementReport/components/base/EngagementReportHero';
import EngagementReport from 'engagementReport/components/base/EngagementReport';
import useSWR from 'swr';
import ResultsSummaryHero from 'engagementReport/components/base/ResultsSummary/ResultsSummaryHero';
import ResultsSummary from '../ResultsSummary';

const EngagementReportContainer = () => {
  const { projectId, engagementReportId, engagementReportSlug } = useParams();
  const reportIdentifier = engagementReportId ?? engagementReportSlug;
  const [data, setData] = useState({
    project: undefined,
    engagementReport: undefined,
  });

  const { data: fetchedProject } = useSWR(projectId ? ['fetchedProject', projectId] : null, () =>
    fetchProject(projectId)
  );
  const { data: fetchedEngagementReport } = useSWR(
    ['fetchedEngagementReport', reportIdentifier],
    () => getEngagementReport(reportIdentifier)
  );

  useEffect(async () => {
    const newData = {};
    if (fetchedProject) newData.project = jsonaDeserialize(fetchedProject);
    if (fetchedEngagementReport) {
      if (fetchedEngagementReport.deserialized.snapshot.type === 'ers_engagement_report') {
        newData.engagementReport = fetchedEngagementReport.deserialized;
      } else {
        // why is the structure different when using SWR?
        const fetchedLegacyEngagementReport = await getEngagementReport(reportIdentifier);
        newData.engagementReport = transformBackendData(fetchedLegacyEngagementReport.deserialized);
      }
    }

    setData(newData);
  }, [fetchedProject, fetchedEngagementReport]);

  if (!data.engagementReport) return null;
  if (projectId && !data.project) return null;

  if (data.engagementReport.snapshot.type === 'ers_engagement_report') {
    return (
      <div className="engagement-report-container">
        <Header project={data.project} />
        <ResultsSummaryHero
          resultsSummary={data.engagementReport.snapshot}
          projectStatus={data.project?.status}
          projectHubEnabled={data.project?.projectHubEnabled}
        />
        <ResultsSummary
          resultsSummary={data.engagementReport.snapshot}
          projectStatus={data.project?.status}
          projectHubEnabled={data.project?.projectHubEnabled}
        />
        <SocialFooter project={data.project} />
        <Footer />
      </div>
    );
  }

  return (
    <div className="engagement-report-container">
      <Header project={data.project} />
      {data.engagementReport && (
        <>
          <EngagementReportHero
            engagementReport={data.engagementReport}
            projectStatus={data.project?.status}
            projectHubEnabled={data.project?.projectHubEnabled}
          />
          <EngagementReport
            engagementReport={data.engagementReport}
            projectStatus={data.project?.status}
            projectHubEnabled={data.project?.projectHubEnabled}
          />
        </>
      )}
      <SocialFooter project={data.project} />
      <Footer />
    </div>
  );
};

export default EngagementReportContainer;
